import React, { useState, useEffect } from "react";
import { FaBook, FaCalendarAlt, FaClock, FaMapMarkerAlt, FaStickyNote, FaClipboardList } from "react-icons/fa";
import studentAxios from "../constants/studentAxios";

const TestSchedule = () => {
  const studentId = localStorage.getItem("studentId");
  const sessionId = localStorage.getItem("currentSessionId");

  const [student, setStudent] = useState(null);
  const [testSchedules, setTestSchedules] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch student data
  useEffect(() => {
    if (!studentId) return;
    const fetchStudent = async () => {
      try {
        const res = await studentAxios.get(`/students/getStudents/${studentId}`);
        setStudent(res.data);
      } catch (err) {
        console.error("Error fetching student:", err);
      }
    };
    fetchStudent();
  }, [studentId]);

  // Fetch test schedules
  useEffect(() => {
    if (!student || !sessionId) return;
    const fetchSchedules = async () => {
      try {
        const res = await studentAxios.get(
          `/testschedules/getTestScheduleByClassNameAndSectionName/${encodeURIComponent(
            student.class
          )}/${encodeURIComponent(student.section)}`,
          { params: { sessionId } }
        );
        setTestSchedules(res.data);
      } catch (err) {
        console.error("Error fetching test schedules:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchSchedules();
  }, [student, sessionId]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen text-lg font-semibold">
        Loading…
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4 md:p-6">
      {testSchedules.length === 0 ? (
        <div className="flex flex-col justify-center items-center bg-white shadow-md rounded-lg p-8 mt-10">
          <FaClipboardList className="text-gray-400 text-6xl mb-4 animate-bounce" />
          <p className="text-gray-600 text-lg">No test schedule available.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {testSchedules.map((test) => (
            <div
              key={test._id}
              className="bg-white p-5 rounded-xl shadow-lg hover:shadow-2xl transition-transform transform hover:-translate-y-1 hover:scale-[1.02]"
            >
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-lg font-semibold text-gray-800 flex items-center">
                  <FaClipboardList className="text-blue-500 mr-2" />
                  {test.testName}
                </h3>
                <span className="bg-green-100 text-green-800 text-xs font-semibold px-2 py-1 rounded-full">
                  {test.subject}
                </span>
              </div>

              <div className="flex items-center text-gray-700 mb-1 text-sm">
                <FaCalendarAlt className="mr-2 text-blue-500" />
                {new Date(test.date).toLocaleDateString()}
              </div>

              <div className="flex items-center text-gray-700 mb-1 text-sm">
                <FaClock className="mr-2 text-purple-500" />
                {test.startTime} - {test.endTime}
              </div>

              <div className="flex items-center text-gray-700 mb-1 text-sm">
                <FaMapMarkerAlt className="mr-2 text-orange-500" />
                Room: {test.roomNumber}
              </div>

              {test.additionalNote && (
                <div className="mt-3 p-2 bg-blue-100 text-blue-800 rounded-lg text-sm flex items-center">
                  <FaStickyNote className="mr-2 text-teal-500" />
                  {test.additionalNote}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TestSchedule;
